import { adminSearchShardCatalogGetSlice } from './get';

export * from './details/actions';
export * from './reindex-customer/actions';

export const {
	requestGetAdminSearchShardCatalog,
	resetGetAdminSearchShardCatalog
} = adminSearchShardCatalogGetSlice.asyncActionCreators;
